<template>
	<div class="drawer">
		<el-drawer
		v-if="curItem.memberId"
		size="600px"
		title="忽略"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<img src="../../../../assets/img/reset.png" class="avatar"/>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">姓名：</span>
						<span class="value">
							{{curItem.memberName}}
						</span>
					</el-col>
				</el-row>
				<!-- <el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">性别：</span>
						<span class="value">
							{{userInfo.basic_info.sex}}
						</span>
					</el-col>
				</el-row> -->
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">手机号：</span>
						<span class="value">
							{{curItem.memberMobile}}
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">原因：</span>
						<span class="value">
							<el-select style="width:380px;" size="mini" class="select" v-model="cause" placeholder="请选择原因">
								<el-option v-for="item in [
									{value:'停机换号',label:'停机换号'},
									{value:'搬家距离远',label:'搬家距离远'},
									{value:'体验不好',label:'体验不好'},
									{value:'不想来了',label:'不想来了'},
									{value:'宠物死亡',label:'宠物死亡'},
									{value:'其他',label:'其他'},
								]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<el-row v-if="cause==='其他'" style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">其他原因：</span>
						<span class="value" style="vertical-align: top;">
							<el-input style="width:380px;" type="textarea" :rows="3" v-model="otherCause" placeholder="请填写其他原因"></el-input>
						</span>
					</el-col>
				</el-row>
				<div>
					<el-button style="width:480px;margin:80px 0 0 80px;" type="primary" @click="submit_check">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				needReply:false,
				cause:'',
				otherCause:'',
				replyContent:'',
				nextReplyTime:'',
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit_check(){
				if(this.cause===''){
					this.$message({
						message: '请选择不再回访原因',
						type: 'error'
					});
					return ;
				}
				if(this.cause==='其他'){
					if(this.otherCause===''){
						this.$message({
							message: '请填写其他原因',
							type: 'error'
						});
						return ;
					}
				}
				let params = {
					"memberId": this.curItem.memberId,
					"needReply": false,
					"cause": this.cause==='其他'?this.otherCause:this.cause,
					"replyContent": '',
					"nextReplyTime": '',
				}
				console.log(params)
				this.$http.post('/api/Platform/InsertReply', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$emit('submit',{type:'success'})
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.label{
				display: inline-block;width:140px;text-align: right;
			}
		}
		
	}
	
</style>
